/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ContainerType_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ContainerType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ContainerType_ {
   /// <summary>
   ///   Partition: Partner-owned root Container for organizing Subjects—and optionally, Areas (even if from another Partition) (.)
   /// </summary>
   Partition = 0,
   /// <summary>
   ///   Subject (optional): Container of Topics (subject)
   /// </summary>
   Subject = 1,
   /// <summary>
   ///   Topic (optional, required child of Subject): Container of Lessons (topic)
   /// </summary>
   Topic = 2,
   /// <summary>
   ///   Lesson: Container of Lesson Content (lesson)
   /// </summary>
   Lesson = 3,
   /// <summary>
   ///   Area (optional): Container of curated Modules (even if from another Partition) (area)
   /// </summary>
   Area = 4,
   /// <summary>
   ///   Module (optional): Container of curated Lessons (even spanning Topics) (module)
   /// </summary>
   Module = 5
}

export const ContainerTypes: ContainerType[] = [
   {
      code: ContainerType_.Partition,
      literal: 'Partition',
      description: 'Partition: Partner-owned root Container for organizing Subjects—and optionally, Areas (even if from another Partition)',
      shortDescription: '.',
      listPriority: 0,

      typeName: "ContainerType"
   },
   {
      code: ContainerType_.Subject,
      literal: 'Subject',
      description: 'Subject (optional): Container of Topics',
      shortDescription: 'subject',
      listPriority: 1,

      typeName: "ContainerType"
   },
   {
      code: ContainerType_.Topic,
      literal: 'Topic',
      description: 'Topic (optional, required child of Subject): Container of Lessons',
      shortDescription: 'topic',
      listPriority: 2,

      typeName: "ContainerType"
   },
   {
      code: ContainerType_.Lesson,
      literal: 'Lesson',
      description: 'Lesson: Container of Lesson Content',
      shortDescription: 'lesson',
      listPriority: 3,

      typeName: "ContainerType"
   },
   {
      code: ContainerType_.Area,
      literal: 'Area',
      description: 'Area (optional): Container of curated Modules (even if from another Partition)',
      shortDescription: 'area',
      listPriority: 0,

      typeName: "ContainerType"
   },
   {
      code: ContainerType_.Module,
      literal: 'Module',
      description: 'Module (optional): Container of curated Lessons (even spanning Topics)',
      shortDescription: 'module',
      listPriority: 2,

      typeName: "ContainerType"
   }
]

export class ContainerType implements IDomainModel {
   code: ContainerType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: ContainerType_): ContainerType {
      return ContainerTypes.find(d => d.code === code)
   }
}
